import { useCallback, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import { Close as CloseIcon } from '@mui/icons-material'

// Canvas width multiplier — chart renders at this multiple of the visible area,
// so the user can pan to reveal content that would otherwise be clipped.
const CANVAS_SCALE = 1.7

export const PanSurface = ({ children }) => {
	const [translateX, setTranslateX] = useState(0)
	const dragging = useRef(false)
	const lastPos = useRef({ x: 0, y: 0 })
	const currentTranslate = useRef({ x: 0, y: 0 })
	const containerRef = useRef(null)

	const onPointerDown = useCallback((e) => {
		dragging.current = true
		lastPos.current = { x: e.clientX, y: e.clientY }
		e.currentTarget.setPointerCapture(e.pointerId)
	}, [])

	const onPointerMove = useCallback((e) => {
		if (!dragging.current) return
		const dx = e.clientX - lastPos.current.x
		lastPos.current = { x: e.clientX, y: e.clientY }

		const container = containerRef.current
		const minX = container ? container.offsetWidth - container.offsetWidth * CANVAS_SCALE : -9999
		const maxX = 0

		currentTranslate.current = {
			x: Math.min(maxX, Math.max(minX, currentTranslate.current.x + dx)),
			y: 0,
		}

		setTranslateX(currentTranslate.current.x)
	}, [])

	const onPointerUp = useCallback(() => {
		dragging.current = false
	}, [])

	return (
		<div
			ref={containerRef}
			className="scout-chart-pan"
			onPointerDown={onPointerDown}
			onPointerMove={onPointerMove}
			onPointerUp={onPointerUp}
			onPointerCancel={onPointerUp}
		>
			<div
				className="scout-chart-pan__canvas"
				style={{
					width: `${CANVAS_SCALE * 100}%`,
					transform: `translateX(${translateX}px)`,
				}}
			>
				{children}
			</div>
			<div className="scout-chart-pan__hint" aria-hidden="true">
				Arraste para explorar
			</div>
		</div>
	)
}

export const ChartModal = ({ title, onClose, children }) => {
	return createPortal(
		<div className="scout-chart-modal" role="dialog" aria-modal="true" aria-label={title}>
			<div className="scout-chart-modal__header">
				<h2 className="scout-chart-modal__title">{title}</h2>
				<button type="button" className="scout-chart-modal__close" onClick={onClose} aria-label="Fechar gráfico">
					<CloseIcon />
				</button>
			</div>
			<PanSurface>
				{children}
			</PanSurface>
		</div>,
		document.body
	)
}
